import { useFragment, useLazyQuery } from '@apollo/client/react';
import { InfoButton, InfoButtonTrigger } from '@optools/components/info-button';
import { Card } from '@optools/components/ui/card';
import { BTC_GAME_FRAGMENT } from '@optools/services/operator-gateway/btc/fragments';
import { BTC_GAME_CONTENT } from '@optools/services/operator-gateway/btc/queries';
import { MediaDetails } from '@optools/tools/btc-tools/components/media-details';
import { SyncAssetsButton } from '@optools/tools/btc-tools/components/sync-assets-button';
import { sortByFeedType } from '@optools/utils/feeds';
import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { RefreshCcw } from 'lucide-react';

export const Route = createFileRoute('/_auth/btc-tools/schedule/$gamePk/content')({
  component: RouteComponent,
});

export function RouteComponent() {
  const { date } = useSearch({ from: '/_auth/btc-tools/schedule' });
  const { gamePk } = useParams({ from: '/_auth/btc-tools/schedule/$gamePk' });

  const [refreshMedia, { called, loading, refetch }] = useLazyQuery(BTC_GAME_CONTENT, {
    fetchPolicy: 'network-only',
  });

  const gameFragment = useFragment({
    fragment: BTC_GAME_FRAGMENT,
    fragmentName: 'BTCGameFields',
    from: { __typename: 'Game', gamePk },
  });

  if (!gameFragment.complete) return null;

  const { data: game } = gameFragment;
  const { content, pipelines } = game;

  return (
    <section>
      <p className="mb-4 text-sm">
        Metadata about a broadcast that is available for streaming on MLB.TV
      </p>
      <div className="mb-4 flex items-center justify-end gap-2">
        {pipelines?.length ? <SyncAssetsButton gamePk={gamePk} /> : null}
        {content.length ? (
          <InfoButton description="Refetches the media to ensure the UI is up to date." size="sm">
            <InfoButtonTrigger
              disabled={loading}
              onClick={() =>
                void (called
                  ? refetch()
                  : refreshMedia({ variables: { gamePk, scheduleDate: date } }))
              }>
              <RefreshCcw />
              Refresh Media
            </InfoButtonTrigger>
          </InfoButton>
        ) : null}
      </div>

      <div className="flex flex-col gap-y-4">
        {content.length ? (
          sortByFeedType(content).map((item) => {
            return (
              <Card
                key={item.mediaId}
                className="w-full overflow-x-auto p-2"
                data-testid={`content-${item.mediaId}`}>
                <MediaDetails content={item} gamePk={gamePk} />
              </Card>
            );
          })
        ) : (
          <div className="flex h-56 items-center justify-center border border-dashed">
            <p>No Media</p>
          </div>
        )}
      </div>
    </section>
  );
}
